<template>
  <div class="mission__reward">
    <div class="mission__label" :class="{ 'mission__label--complete': missionComplete }">
      {{ getRewardLabel }}
    </div>
    <div class="mission__wallets">
      <div v-for="(item, count) in getRewardList" :key="count" :class="getRewardItemClass()">
        <template v-if="showReward('currency', item)">
          <i class="icon icon-free-points"></i>
          <span>{{ item.reward.count }}</span>
        </template>

        <template v-if="showReward('game_item', item)">
          <i
            :key="item.reward.item.id"
            :name="getTooltipName(item, index)"
            class="icon icon-prize"
          ></i>

          <tippy :to="getTooltipName(item, index)" theme="wf-bp access-list" :arrow="false">
            <div>
              <img :src="getImageSrc(item)" :alt="item.title" />
              <p>{{ item.title }} ({{ itemDuration(item.reward).text }})</p>
            </div>
          </tippy>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import ItemDurationMixin from "../../Common/ItemDurationMixin";

export default {
  name: "MissionsListOneInfoRewards",
  mixins: [ItemDurationMixin],
  props: {
    missionRewards: Array,
    missionComplete: Boolean,
    index: Number,
  },
  data() {
    return {
      icons: {
        currency: "icon-free-points",
        game_item: "icon-star",
      },
    };
  },
  computed: {
    getRewardList() {
      let result = this.missionRewards;

      //TODO: bad, bad compare function based on 'currency' < 'game_item'
      result.sort((item1, item2) => {
        return item1.reward.type < item2.reward.type ? -1 : 1;
      });

      return result;
    },
    getRewardLabel() {
      return this.missionComplete
        ? this.$t("missions.list.received")
        : this.$t("missions.list.reward");
    },
    isOneReward() {
      return this.getRewardList.length === 1;
    },
  },
  methods: {
    getImageSrc(item) {
      return `https://wf.cdn.gmru.net/static/wf.mail.ru/img/main/items/${item.reward.item.id}.png`;
    },
    getTooltipName(item, index) {
      return `reward_tooltip-${item.reward.item.id}_${index}`;
    },
    showReward(reward_type, item) {
      return item.reward.type === reward_type;
    },
    getRewardItemClass() {
      return ["mission__wallets__item", this.isOneReward ? "only-reward" : ""];
    },
  },
};
</script>
